var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup166(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 63,
    viewBox: "0 0 51 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0224609 61.0274H6.47493M47.063 61.0274H23.5427M23.5427 61.0274H6.47493M23.5427 61.0274C23.5427 61.0274 22.3467 57.7934 20.9826 54.1226M6.47493 61.0274L8.87165 54.1226M8.87165 54.1226L12.0948 44.8369C13.3034 41.5884 16.0496 41.0274 17.5066 44.8369C18.2189 46.6994 19.6776 50.6109 20.9826 54.1226M8.87165 54.1226H20.9826M13.3437 33.6464C3.76906 41.0274 11.6785 54.3607 21.4613 42.9321M41.235 50.075C18.7554 49.5988 7.09271 28.1666 7.09936 11.9797V11.7416M41.235 50.075C43.0805 49.9278 43.5246 48.1702 42.2757 46.7417C42.0445 46.4772 40.8077 45.0624 38.9454 42.9321M41.235 50.075L7.09936 11.7416M7.09936 11.7416C7.09936 9.36067 9.20573 8.87402 10.4297 10.3131C10.4297 10.3131 30.7475 33.5545 38.9454 42.9321M38.9454 42.9321V19.3607M38.9454 19.3607L33.95 13.8845C31.7947 16.5094 33.7418 21.9797 38.9454 19.3607Z",
    stroke: "#006D77",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3345 8.64689C26.2485 17.6945 32.4928 25.7898 43.3163 31.504M33.5335 4.36117C36.1355 12.7796 39.4684 15.8392 47.0629 19.8374M42.4837 1.02783C44.4673 5.4259 46.0802 7.28944 49.9769 9.36117",
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup166);
export default __webpack_public_path__ + "static/media/Group 166.2e56d4870bd1af64e01e27428ad71c13.svg";
export { ForwardRef as ReactComponent };